import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";
import MapFilterModel, {
  ModifiedMapFilterModel,
} from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import standardMergeFilterModels from "@app/component/view/utils/mergeFilterModels";

// same as standardMergeFilterModels, but for maps
const mergeFilterModels = (
  existingFilterModel: MapFilterModel,
  newFilterModel: ModifiedMapFilterModel
): MapFilterModel => {
  const resultingFilterModel: MapFilterModel = { ...existingFilterModel };

  (Object.keys(newFilterModel) as MapFilterEntityType[]).forEach((entityType) => {
    if (isDefined(newFilterModel[entityType]) && Object.keys(newFilterModel[entityType]!).length) {
      resultingFilterModel[entityType] = standardMergeFilterModels(
        resultingFilterModel[entityType] ?? {},
        newFilterModel[entityType]!
      );
    } else {
      resultingFilterModel[entityType] = undefined;
    }
  });

  return resultingFilterModel;
};

export default mergeFilterModels;
